<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          История звонков <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Новый звонок ИСПОЛЬЗОВАТЬ ТОЛЬКО ДЛЯ НОВОЙ ВЕТКИ ЗВОНКОВ
          <i v-on:click="newCall" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :page-limits="pageLimits" :hide-pages="true"
             :new-one="newOne" @resetNew="newOne = null" @update_top="update"></big-one>
  </div>
</template>
<script>

import {userService} from "@/services/user.service";

const callTime = {header: "Дата звонка", name: "date", show: true, sort: true, direction: true};
const callProjectDate = {header: "Плановая дата звонка", name: "projectDate", show: true, sort: true, direction: true, date: true};
const caller = {header: "Звонил", name: "executorData.name", show: true};
const callNextTime = {header: "Позвонить", name: "nextDate", show: true, sort: true, direction: true}
const callNote = {header: "Итоги беседы", name: "note", show: true};

export default{
  name: 'client-call-history',
  components:{
  },
  props:{
    item: {}
  },
  data() {
    return {
      content: [callTime, callProjectDate, caller, callNextTime, callNote],
      type: "call",
      pageLimits: {client: this.item.id},
      newOne: null
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    newCall() {
      //let currentTime = new Date().getTime();
      let object = {/*date: currentTime, nextDate: currentTime,*/  client: this.item, executor: userService.getUser(), id: 0, callIsDone: false};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    },
    update() {
      this.$emit('update');
    }
  }
}
</script>
<style>
</style>
